/* eslint-disable react-hooks/exhaustive-deps, jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Box,
  Typography,
  Button,
  TextField,
  Card,
  CardContent,
  Divider,
  // MenuItem,
  // Select,
  // InputLabel,
  FormControl,
  Checkbox,
  Snackbar,
  Alert,
  AlertTitle,
} from "@mui/material";
import { useTheme } from "../../style/theme";
import Image from "../Image";
import { Grid } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { formatDateToReadable } from "../../utilities/helper";
import axios from "axios";
import starterImg from "../../assets/startericon.png";
import privateImg from "../../assets/privateicon.png";
import businessImg from "../../assets/businessicon.png";
import enterpriseImg from "../../assets/enterpriseicon.png";
import Loader from "../../assets/loader.gif";
import { useUser } from "../../hooks/Authorize";

const PlanDetails = () => {
  <style>
    {`
    select:focus {
      outline: none;
      border-color: black !important;
    }

    select option {
      background-color: transparent;
      color: #9ca3af;
    }
  `}
  </style>;
  const platformUser = useUser();
  const [loading, setLoading] = useState(false);
  // const [LoadingPlans, setLoadingPlans] = useState(false);
  const location = useLocation();
  const plan = location.state?.plan;
  const UserCount = location.state?.totalEmployees ?? 0;
  const id = location.state?.id ?? 0;
  const email = location.state?.organizationInfo?.portalName ?? "";
  const [selectedPlan, setSelectedPlan] = useState(plan);
  const currDate = new Date();
  const [billingCycle, setBillingCycle] = useState("Yearly");
  const [nextBillingDate, setNextBillingDate] = useState("");
  const [FilesPlans, setFilesPlans] = useState();
  const [filesSubscription, setFilesSubscription] = useState();
  const [subscriptionUser, setSubscriptionUser] = useState(null);
  const billingCycleAmount = selectedPlan?.amount;
  const [showMessage, setShowMessage] = useState({
    show: true,
    message: "",
    severity: "",
  });
  // const UserCount = 14;

  const handleClose = () => {
    setShowMessage({ show: false, message: " ", severity: "" });
  };

  const getFilesPlans = async (interval) => {
    // setLoadingPlans(true);
    try {
      const response = await axios.get(
        `/store/plan/files?interval=${interval}`
      );
      const fetchedPlans = response.data.data;
      setFilesPlans(fetchedPlans);
    } catch (error) {
      console.error("Failed to fetch plans:", error);
      // setLoadingPlans(false);
    } finally {
      // setLoadingPlans(false);
    }
  };

  const getSubscription = async () => {
    // setLoadingPlans(true); // 👈 start loading
    try {
      const response = await axios.post(`/subscription/check-hr`, {
        orgId: id,
        userId: platformUser?._id,
      });
      const subscription = response.data.subscription;
      console.log(subscriptionUser?.addons?.noOfUsers, "subscription");
      setSubscriptionUser(subscription);
    } catch (error) {
      console.error("Failed to fetch plans:", error);
    } finally {
      // setLoadingPlans(false); // 👈 stop loading
    }
  };

  const getFilesSubscription = async () => {
    try {
      const response = await axios.get(
        `/subscription/check-file/${platformUser?._id}`
      );
      const fetchedFilesSubscription = response?.data?.subscription;
      setFilesSubscription(fetchedFilesSubscription);
    } catch (error) {
      console.error("Failed to fetch organizations:", error);
    }
  };

  const [formData, setFormData] = useState({
    noOfUsers: UserCount,
    billingCycle: billingCycle,
    extraStorage: "",
  });
  console.log("🚀 ~ PlanDetails ~ formData:", formData);

  useEffect(() => {
    if (subscriptionUser?.addons?.noOfUsers !== undefined) {
      setFormData((prev) => ({
        ...prev,
        noOfUsers: Number(subscriptionUser?.addons?.noOfUsers),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        noOfUsers: UserCount,
      }));
    }
  }, [subscriptionUser]);

  const noOfUsers = {
    usersPrice:
      billingCycle === "Yearly"
        ? {
            label: `$${billingCycleAmount}/user/year`,
            price: billingCycleAmount,
          }
        : {
            label: `$${billingCycleAmount}/user/month`,
            price: billingCycleAmount,
          },
  };

  const handleChange = (label, value) => {
    setFormData((prev) => ({ ...prev, [label]: value }));
  };

  const calculateTotal = () => {
    let total = 0;
    const noOfUserPrice = billingCycleAmount;

    addons.forEach((addon) => {
      if (addon.select && formData[addon.type]) {
        const selectedOption = addon.options.find(
          (opt) => opt.label === formData[addon.type]?.label
        );
        if (selectedOption) {
          total += selectedOption.price;
        }
      } else if (addon.checkbox && formData[addon.label]) {
        total += addon.price;
      } else if (!addon.select && !addon.checkbox && formData[addon.label]) {
        const quantity = Number(formData[addon.label]);
        if (!isNaN(quantity)) {
          total += quantity * addon.price;
        }
      }
    });

    if (formData.noOfUsers > 0) {
      total += formData.noOfUsers * noOfUserPrice;
    }

    return total;
  };

  const addons = [
    {
      label: billingCycle === "Yearly" ? " Non User" : "Non User",
      price: billingCycle === "Yearly" ? 240 : 20,
      unit: `/user/${billingCycle?.toLowerCase()}}`,
    },
    {
      label: "Support",
      select: true,
      type: "support",
      options: [
        {
          label:
            billingCycle === "Yearly" ? " Basic Supports" : "Basic Supports",
          price: billingCycle === "Yearly" ? 120 : 10,
        },
        {
          label:
            billingCycle === "Yearly"
              ? " Premium Supports"
              : "Premium Supports",
          price: billingCycle === "Yearly" ? 168 : 14,
        },
        {
          label:
            billingCycle === "Yearly"
              ? " Dedicated Supports"
              : "Dedicated Supports",
          price: billingCycle === "Yearly" ? 240 : 20,
        },
      ],
    },
    {
      label: billingCycle === "Yearly" ? " Cases" : "Cases",
      price: billingCycle === "Yearly" ? 72 : 6,
      unit: `/user/${billingCycle?.toLowerCase()}}`,
      checkbox: true,
    },
    {
      label: billingCycle === "Yearly" ? " Extra Reports" : "Extra Reports",
      price: billingCycle === "Yearly" ? 1200 : 100,
      unit: `/unit/${billingCycle?.toLowerCase()}}`,
      checkbox: true,
    },
    {
      label:
        billingCycle === "Yearly"
          ? " Employee Engagement"
          : "Employee Engagement",
      price: billingCycle === "Yearly" ? 300 : 25,
      unit: `/employee/${billingCycle?.toLowerCase()}}`,
      checkbox: true,
    },
    {
      label: billingCycle === "Yearly" ? " Recruiters" : "Recruiters",
      price: billingCycle === "Yearly" ? 5400 : 450,
      unit: `/recruiter/${billingCycle?.toLowerCase()}}`,
    },
    {
      label: billingCycle === "Yearly" ? "Extra Forms" : "Extra Form",
      select: true,
      type: "extraForms",
      options: [
        {
          label: billingCycle === "Yearly" ? " 20 forms" : "20 forms",
          price: billingCycle === "Yearly" ? 660 : 55,
        },
        {
          label: billingCycle === "Yearly" ? " 40 forms" : "40 forms",
          price: billingCycle === "Yearly" ? 840 : 70,
        },
        {
          label: billingCycle === "Yearly" ? " 60 forms" : "60 forms",
          price: billingCycle === "Yearly" ? 1080 : 90,
        },
        {
          label: billingCycle === "Yearly" ? " 80 forms" : "80 forms",
          price: billingCycle === "Yearly" ? 1440 : 120,
        },
        {
          label: billingCycle === "Yearly" ? " 100 forms" : "100 forms",
          price: billingCycle === "Yearly" ? 1040 : 170,
        },
      ],
    },
    {
      label: "Extra Storage",
      select: true,
      type: "extraStorage",
      options:
        FilesPlans?.map((perm, index) => ({
          label: `${perm?.name} ${perm?.permission[2]?.content}`,
          price: billingCycle === "Yearly" ? perm?.amount : perm?.amount,
        })) || [],
    },
    {
      label: "Jumpstart",
      select: true,
      type: "jumpStart",
      options: [
        {
          label:
            billingCycle === "Yearly"
              ? " Private session (20 hrs)"
              : "Private session (20 hrs)",
          price: billingCycle === "Yearly" ? 6120 : 510,
        },
        {
          label:
            billingCycle === "Yearly"
              ? " Business session (30 hrs)"
              : "Business session (30 hrs)",
          price: billingCycle === "Yearly" ? 11520 : 960,
        },
        {
          label:
            billingCycle === "Yearly"
              ? " Enterprise session (50 hrs)"
              : "Enterprise session (50 hrs)",
          price: billingCycle === "Yearly" ? 12000 : 1000,
        },
        {
          label:
            billingCycle === "Yearly"
              ? " Clikkle-session (70 hrs)"
              : "EClikkle-session (70 hrs)",
          price: billingCycle === "Yearly" ? 18000 : 1500,
        },
      ],
    },
  ];
  const calculateNextBillingDate = () => {
    const today = new Date();
    let nextDate;

    if (billingCycle === "Yearly") {
      nextDate = new Date(today.setFullYear(today.getFullYear() + 1));
    } else {
      nextDate = new Date(today.setMonth(today.getMonth() + 1));
    }

    // Format: Jan 15, 2025
    const formattedDate = nextDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

    setNextBillingDate(formattedDate);
  };

  const steps = ["Plan", "Add-Ons", "Pay", "Confirmation"];
  const activeSteps = [0, 1];

  const navigate = useNavigate();

  const handleChangeNext = () => {
    const totalAddons = calculateTotal();
    const value = formData.noOfUsers;
    const MIN_USERS = 10;

    if (value === "") {
      setFormData((prev) => ({ ...prev, noOfUsers: "" }));
      setShowMessage({
        show: true,
        message: `Number of users cannot be empty. Minimum required is ${MIN_USERS}.`,
        severity: "error",
      });
      return;
    }

    const numericValue = parseInt(value, 10);

    if (isNaN(numericValue)) {
      setShowMessage({
        show: true,
        message: "Please enter a valid number of users.",
        severity: "error",
      });
      return;
    }

    if (numericValue < MIN_USERS) {
      setShowMessage({
        show: true,
        message: `Minimum number of users must be ${MIN_USERS}.`,
        severity: "error",
      });
      setFormData((prev) => ({ ...prev, noOfUsers: UserCount }));
      return;
    }

    if (numericValue < UserCount) {
      setShowMessage({
        show: true,
        message: `Number of users cannot be less than ${UserCount}. Your organization already has ${UserCount} user(s) assigned.`,
        severity: "error",
      });
      setFormData((prev) => ({ ...prev, noOfUsers: UserCount }));
      return;
    }

    setFormData((prev) => ({ ...prev, noOfUsers: numericValue }));

    const subscriptionSummary = {
      plan: selectedPlan,
      email: email,
      billingCycle,
      billingCycleAmount,
      adonsData: formData,
      nextBillingDate,
      currDate: formatDateToReadable(currDate),
      totalAmount: totalAddons,
      noOfUsers: noOfUsers?.usersPrice?.label,
      FilesPlans: FilesPlans,
    };

    navigate("/pay-step", { state: { subscriptionSummary, id } });
  };

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page in the history stack
  };

  const getPlanDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`/store/plan/detail`, {
        name: plan?.name,
        interval: billingCycle === "Monthly" ? "month" : "year",
        type: "hr",
      });
      const fetchPlan = response?.data?.data;
      setLoading(false);
      setSelectedPlan(fetchPlan);
      calculateNextBillingDate();
      getFilesPlans(billingCycle === "Monthly" ? "month" : "year");
    } catch (error) {
      console.error("Failed to fetch organizations:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPlanDetails();
    getFilesSubscription();
    getSubscription();
  }, [plan, billingCycle]);

  const { mode } = useTheme();
  if (!selectedPlan) {
    return (
      <Box
        sx={{
          backgroundColor: "#121212",
          color: "#fff",
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h5"
          sx={{ color: mode === "light" ? "black" : "#E53935" }}
        >
          Plan not found! Please check the URL.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        overflow: "hidden",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Snackbar
        open={showMessage.show}
        autoHideDuration={4000}
        onClose={handleClose}
      >
        <Alert
          severity={showMessage.severity}
          variant="filled"
          sx={{ width: "100%" }}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <AlertTitle> {showMessage.severity}</AlertTitle>
          {showMessage.message}
        </Alert>
      </Snackbar>
      <Box>
        <Button
          onClick={handleBackClick}
          sx={{
            color: mode === "light" ? "#26272C" : "#FFFFFF",
            // padding: "0.5rem 1rem",
            fontSize: "15px",
            display: "flex",
            alignItems: "center",
            borderRadius: "5px",
          }}
        >
          <ArrowBackIcon sx={{ marginRight: "0.5rem" }} />
        </Button>
      </Box>

      <Box>
        {/* Header */}
        <Typography
          variant="h6"
          sx={{
            color: mode === "light" ? "#26272C" : "#A5A5A5",
            textAlign: "center",
          }}
        >
          Subscribe to Clikkle{" "}
          <span style={{ color: "#3B84D9", fontWeight: "bold" }}>HR</span> in 4
          Easy Steps
        </Typography>
      </Box>

      {/* Steps */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          py: 3,
          px: { xs: "2rem", sm: "5rem" },
          mb: "2rem",
        }}
      >
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                zIndex: 1,
                mb: "-1.5rem",
                gap: "0.6rem",
                minWidth: { xs: "70px", sm: "auto" }, // prevent shrink on small
              }}
            >
              <Box
                sx={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: activeSteps.includes(index)
                    ? "#407BFF"
                    : "transparent",
                  border: "1px solid gray",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: activeSteps.includes(index) ? "#fff" : "#A5A5A5",
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              >
                {index + 1}
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  color: activeSteps.includes(index) ? "black" : "#A5A5A5",
                  fontSize: { xs: "0.75rem", sm: "0.9rem" },
                  width: { xs: "60px", sm: "auto" },
                }}
              >
                {step}
              </Typography>
            </Box>
            {index < steps.length - 1 && (
              <Box
                sx={{
                  flex: 1,
                  height: "1px",
                  backgroundColor:
                    activeSteps.includes(index) &&
                    activeSteps.includes(index + 1)
                      ? "#407BFF"
                      : "#A5A5A5",
                  mx: { xs: "auto", sm: "10px" }, // margin X
                  my: { xs: "0.7rem", sm: 0 }, // margin Y
                  width: { xs: "60%", sm: "100%" },
                }}
              />
            )}
          </React.Fragment>
        ))}
      </Box>

      <Grid
        container
        spacing={2}
        sx={{ px: 2, height: "100%", overflow: "hidden" }}
      >
        <Grid
          item
          xs={12}
          md={8}
          sx={{
            height: "100%",
            overflowY: "auto",
            pr: 2,
            py: 1,
            scrollbarWidth: "none", // Firefox
            "&::-webkit-scrollbar": {
              width: 0,
              height: 0,
            },
            "&:hover::-webkit-scrollbar": {
              width: "8px",
            },
            "&:hover::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
            },
            "&:hover::-webkit-scrollbar-track": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Box
            sx={{
              pr: 2, // Optional: padding right for scrollbar
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "1rem",
              }}
            >
              <Box
                sx={{
                  backgroundColor: mode === "light" ? "white" : "#1c1c1c", // Dark container
                  borderRadius: "999px", // Fully rounded
                  display: "flex",
                  padding: "4px",
                }}
              >
                <Button
                  onClick={() => {
                    setBillingCycle("Yearly");
                    setFormData({
                      noOfUsers: UserCount,
                      billingCycle: "Yearly",
                    });
                  }}
                  sx={{
                    borderRadius: "999px",
                    color:
                      billingCycle === "Yearly"
                        ? "#fff"
                        : mode === "light"
                        ? "black"
                        : "#ccc",
                    backgroundColor:
                      billingCycle === "Yearly" ? "#007aff" : "transparent",
                    textTransform: "none",
                    fontWeight: 600,
                    px: 3,
                    "&:hover": {
                      backgroundColor:
                        billingCycle === "Yearly" ? "#007aff" : "transparent",
                    },
                  }}
                >
                  Yearly
                </Button>
                <Button
                  onClick={() => {
                    setBillingCycle("Monthly");
                    setFormData({
                      noOfUsers: UserCount,
                      billingCycle: "Monthly",
                    });
                  }}
                  sx={{
                    borderRadius: "999px",
                    color:
                      billingCycle === "Monthly"
                        ? "#fff"
                        : mode === "light"
                        ? "black"
                        : "#ccc",
                    backgroundColor:
                      billingCycle === "Monthly" ? "#007aff" : "transparent",
                    textTransform: "none",
                    fontWeight: 600,
                    px: 3,
                    "&:hover": {
                      backgroundColor:
                        billingCycle === "Monthly" ? "#007aff" : "transparent",
                    },
                  }}
                >
                  Monthly
                </Button>
              </Box>

              {/* Discount Message */}
              <Typography sx={{ color: "#3B84D9", marginTop: "5px" }}>
                Get discount on yearly subscription
              </Typography>
            </Box>

            {/*  */}

            {/* Card shifted below Toggle Button */}
            <Card
              sx={{
                backgroundColor:
                  mode === "light" ? "white" : "rgba(7, 7, 7, 0.43)",
                border: `1px solid ${mode === "light" ? "#e5e7eb" : "#2E2E2E"}`,
                borderRadius: "10px",
                padding: "16px",
                position: "relative",
                marginTop: "4rem",
                alignSelf: "flex-start",
              }}
            >
              <CardContent>
                {/* Header Section */}
                <Box
                  width="100%"
                  display="flex"
                  alignItems="center"
                  gap={1}
                  borderBottom={`1px solid ${
                    mode === "light" ? "#e5e7eb" : "#292929"
                  }`}
                  pb={2}
                  alignSelf="flex-start"
                  mt="-1rem"
                >
                  <Box
                    sx={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      backgroundColor: "white",
                      border: `1px solid ${
                        mode === "light" ? "#d1d5db" : "#2E2E2E"
                      }`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Image
                      src={
                        plan?.name === "Free"
                          ? starterImg
                          : plan?.name === "Pro"
                          ? privateImg
                          : plan?.name === "Team"
                          ? businessImg
                          : enterpriseImg
                      }
                      alt="logo"
                      width={20}
                      height={20}
                    />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "25px",
                      fontWeight: "600",
                      color: mode === "light" ? "#000" : "#fff",
                    }}
                  >
                    {selectedPlan.name || "N/A"}
                  </Typography>
                </Box>

                {/* User Input Section */}
                <Box
                  mt={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box display="flex" flexDirection="column">
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: mode === "light" ? "black" : "#FFFFFF",
                      }}
                    >
                      No of users
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        color: "#A5A5A5",
                        marginTop: "10px",
                      }}
                    >
                      {noOfUsers.usersPrice?.label}
                    </Typography>
                  </Box>
                  <TextField
                    variant="outlined"
                    size="small"
                    name="noOfUsers"
                    value={formData.noOfUsers || ""}
                    onChange={(e) => handleChange("noOfUsers", e.target.value)}
                    sx={{
                      width: "130px",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: mode === "light" ? "#d1d5db" : "#2E2E2E",
                        },
                      },
                      marginTop: "10px",
                    }}
                  />
                </Box>
              </CardContent>
            </Card>

            <Card
              sx={{
                backgroundColor:
                  mode === "light" ? "white" : "rgba(7, 7, 7, 0.43)",
                border: `1px solid ${mode === "light" ? "#e5e7eb" : "#2E2E2E"}`,
                borderRadius: "10px",
                padding: "16px",
                position: "relative",
                marginTop: "2rem",
                alignSelf: "flex-start",
              }}
            >
              <CardContent>
                {/* ADD-ONS Header */}
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: mode === "light" ? "#000" : "#FFFFFF",
                    borderBottom: `1px solid ${
                      mode === "light" ? "#e5e7eb" : "#292929"
                    }`,
                    paddingBottom: "10px",
                  }}
                >
                  ADD-ONS
                </Typography>

                {/* ADD-ONS List */}
                {addons.map((addon, index) => (
                  <Box
                    key={index}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    mt={1}
                    pb={2}
                    sx={{
                      borderBottom:
                        index !== addons.length - 1
                          ? `1px solid ${
                              mode === "light" ? "#e5e7eb" : "#292929"
                            }`
                          : "none",
                    }}
                  >
                    {/* Label & Price */}
                    <Box display="flex" flexDirection="column">
                      <Typography
                        sx={{
                          fontSize: "15px",
                          fontWeight: "500",
                          color: mode === "light" ? "#000" : "#FFFFFF",
                        }}
                      >
                        {addon.label}
                      </Typography>
                      {addon.price && (
                        <Typography
                          sx={{
                            fontSize: "12px",
                            color: "#A5A5A5",
                            marginTop: "8px",
                          }}
                        >
                          {addon.price}
                        </Typography>
                      )}
                    </Box>

                    {/* Field */}
                    <Box display="flex" alignItems="center">
                      {addon.select ? (
                        <FormControl
                          variant="outlined"
                          size="small"
                          sx={{ width: "130px" }}
                        >
                          {/* <InputLabel id={`select-${index}-label`}>
                            Select
                          </InputLabel>
                          <Select
                            labelId={`select-${index}-label`}
                            value={SelectValue}
                            label="Select"
                            onChange={(e) => {
                              handleChange(addon.type, e.target.value)
                              
                           } }
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor:
                                    mode === "light" ? "#d1d5db" : "#2E2E2E",
                                },
                              },
                            }}
                          >
                            {addon.options.map((item, index) => (
                              <MenuItem value={item} key={index}>
                                {item.label} - ${item.price}/{billingCycle?.toLowerCase()}
                              </MenuItem>
                            ))}
                          </Select> */}
                          <select
                            value={formData?.[addon.type]?.label || ""}
                            onChange={(e) => {
                              const selectedOption = addon.options.find(
                                (opt) => opt.label === e.target.value
                              );
                              handleChange(addon.type, selectedOption);
                            }}
                            style={{
                              backgroundColor:
                                mode === "light" ? "white" : "#1A1A1A",
                              color: mode === "light" ? "black" : "white",
                              border: "1px solid rgb(188, 188, 194)",
                              borderRadius: "4px",
                              padding: "8px 12px",
                              width: "100%",
                              appearance: "none",
                              WebkitAppearance: "none",
                              MozAppearance: "none",
                              fontSize: "14px",
                              height: "40px",
                            }}
                          >
                            <option value="">select</option>
                            {addon.options.map((item, index) => {
                              const firstWord = item.label
                                .split(" ")[0]
                                .toLowerCase();
                              const planName =
                                filesSubscription?.planName?.toLowerCase();
                              const isDisabled = firstWord === planName;

                              return (
                                <option
                                  key={index}
                                  value={item.label}
                                  disabled={isDisabled}
                                >
                                  {item.label} - ${item.price}/
                                  {billingCycle?.toLowerCase()}
                                </option>
                              );
                            })}
                          </select>
                        </FormControl>
                      ) : addon.checkbox ? (
                        <Checkbox
                          checked={formData[addon.label] || false}
                          onChange={(e) =>
                            handleChange(addon.label, e.target.checked)
                          }
                          sx={{
                            color: mode === "light" ? "#000" : "#FFFFFF",
                          }}
                        />
                      ) : (
                        <TextField
                          variant="outlined"
                          size="small"
                          value={formData[addon.label] || ""}
                          onChange={(e) =>
                            handleChange(addon.label, e.target.value)
                          }
                          sx={{
                            width: "130px",
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor:
                                  mode === "light" ? "#d1d5db" : "#2E2E2E",
                              },
                            },
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                ))}
              </CardContent>
            </Card>
          </Box>{" "}
          <Box display="flex" py={2} mt={2}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#45413C", // Dark gray background
                color: "#A5A5A5", // Light gray text
                borderRadius: "8px", // Rounded corners
                padding: "8px 24px", // Padding for better size
                "&:hover": { backgroundColor: "#333333" }, // Slightly darker on hover
              }}
              onClick={handleChangeNext}
            >
              Next
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} md={4} sx={{ height: "100%", overflow: "visible" }}>
          {/* Subscriptions Summarry card */}
          <Box
            sx={{
              position: "relative",
              borderRadius: "10px",
              overflow: "hidden",
              p: "2px", // for visible gradient border thickness
              background: "linear-gradient(45deg, #6A0B61, #3767B1)",
            }}
          >
            <Card
              sx={{
                borderRadius: "inherit",
                backgroundColor: mode === "light" ? "white" : "black",
                width: "100%",
                height: "100%",
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    color: mode === "light" ? "black" : "#FFFFFF",
                    pb: 1, // Adds padding below text
                    borderBottom: "1px solid #5C5C5C", // Adds border below text
                  }}
                >
                  Subscription Summary
                </Typography>

                {/* <Box
                  sx={{
                    backgroundColor: "#3767B11A",
                    color: "#407BFF",
                    fontSize: "12px",
                    fontWeight: "bold",
                    padding: "4px 10px",
                    borderRadius: "4px",
                    display: "inline-block",
                    marginTop: "14px",
                  }}
                >
                  14 DAYS LEFT IN TRIAL
                </Box> */}
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box display="flex" alignItems="center" mt="1rem">
                    <Box
                      sx={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        backgroundColor: "white",
                        border: `1px solid ${
                          mode === "light" ? "#d1d5db" : "#2E2E2E"
                        }`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "8px", // Adds some space between image and text
                        // mt:"2rem"
                      }}
                    >
                      <Image
                        src={
                          plan?.name === "Starter"
                            ? starterImg
                            : plan?.name === "Private"
                            ? privateImg
                            : plan?.name === "Business"
                            ? businessImg
                            : enterpriseImg
                        }
                        alt="logo"
                        width={20}
                        height={20}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "25px",
                        fontWeight: "500",
                        color: mode === "light" ? "black" : "#fff",
                      }}
                    >
                      {selectedPlan.name || "N/A"}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "25px",
                      fontWeight: "500",
                      color: mode === "light" ? "black" : "#fff",
                      mt: "1rem",
                    }}
                  >
                    {loading || !billingCycleAmount ? (
                      <img alt="loading..." src={Loader} width={20} />
                    ) : (
                      <>
                        $
                        {billingCycle === "Yearly"
                          ? billingCycleAmount / 12
                          : billingCycleAmount}
                      </>
                    )}
                    <span style={{ fontSize: "12px" }}> /monthly</span>
                  </Typography>
                </Box>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mt="1rem"
                >
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    Organization URL
                  </Typography>
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    {location?.state?.organizationInfo?.portalName}
                  </Typography>
                </Box>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mt="1rem"
                >
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    Per user
                  </Typography>
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    {noOfUsers.usersPrice?.label}
                  </Typography>
                </Box>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mt="1rem"
                >
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    Billing Cycle
                  </Typography>
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    {billingCycle}
                  </Typography>
                </Box>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mt="1rem"
                >
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    Billing Starts On
                  </Typography>
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    {formatDateToReadable(currDate)}
                  </Typography>
                </Box>

                <Divider sx={{ backgroundColor: "#5C5C5C", marginY: "15px" }} />

                <Box sx={{ mb: "2rem" }}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography
                      sx={{
                        fontSize: "25px",
                        color: mode === "light" ? "black" : "#FFFFFF",
                      }}
                    >
                      {billingCycle === "Yearly" ? "Yearly" : "Monthly"} Total
                    </Typography>
                    <Box sx={{ mt: "1rem" }}>
                      <Typography
                        sx={{
                          fontSize: "25px",
                          color: mode === "light" ? "black" : "#FFFFFF",
                        }}
                      >
                        ${calculateTotal()}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: "12px",
                          textAlign: "right",
                          color: "#A5A5A5",
                        }}
                      >
                        (excluding tax)
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "#A5A5A5",
                    textAlign: "center",
                    mt: "1rem",
                  }}
                >
                  You won’t be charged until {nextBillingDate}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PlanDetails;
